query getMarketingPlan($id: ID) {
  plan: getMarketingPlan(id: $id) {
    id
    market
    locale
    referenceTimezone
    presetLayoutId
    startDate
    status
    scheduleError
    slots {
      id
      platform
      topicId
      topicName
      title
      scheduledLocal {
        date
        time
      }
      hint
      generatedText
      textChoices
      textStatus
      generationError
      imageUrl
      imageStatus
      status
      savedContentId
    }
  }
}
